export const enum Intent {
    Buyer,
    Seller,
}